enum FacturationNetStatus {
    NoStatus = 0,
    // Status (Sortie): Statut de la facture tel que retourné par Facturation.Net :
    Valid = 1, // la facture est valide, non envoyée à  la RAMQ car en mode d’attente.
    Invalid = 2, // facture ayant une ou plusieurs erreurs(de Facturation.Net et/ou de la RAMQ).
    RAMQReceived = 3, // facture valide reçue par la RAMQ
    WaitingToSendRAMQ = 4, // facture valide en attente de transmission.Arrive uniquement en cas de problèmes de communication avec les services de la RAMQ.Facturation.Net va envoyer automatique la facture dès que possible.
    ToBeCancelled = 5, // facture annulée par l’utilisateur, à transmettre à la RAMQ.
    RAMQCancelled = 6 // facture annulée par l’utilisateur, annulation confirmée par la RAMQ.
}

export { FacturationNetStatus };
